module.exports = __webpack_public_path__ + "img/hydra.05a79141.svg";